import { render } from "./Event.vue?vue&type=template&id=39a54abf&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=39a54abf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a54abf"],['__file',"src/containers/event/common/Event.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39a54abf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39a54abf', __exports__)) {
    api.reload('39a54abf', __exports__)
  }
  
  module.hot.accept("./Event.vue?vue&type=template&id=39a54abf&scoped=true", () => {
    api.rerender('39a54abf', render)
  })

}


export default __exports__